
import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { selectAllCarImageSamples, selectAllSearchedCars, selectAllSearchedCarsCount, selectLoggedInUserDataId, selectDealerFavorites, selectDealerMyFavoriteCarsIds } from 'src/app/common/store/state/app.state';
import { CarBusinessLine } from '../../constants/car-basic-data';
import { CarBrief } from '../../models/car-brief.model';
import { CarBoxComponent } from '../car-box/car-box.component';


@Component({
    selector: 'app-car-box-list',
    templateUrl: './car-box-list.component.html',
    styleUrls: ['./car-box-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AsyncPipe, CarBoxComponent]
})
export class CarBoxListComponent implements OnInit {

  @Input() businessLine?: CarBusinessLine;

  progressInfos: any[] = [];
  message: string[] = [];

  //carImages: any[] = [];
  isImageLoading: boolean = false;
  currentImageIndex: number = 0;

  @Input() fetchingResults: boolean;
  @Input() carBriefs: CarBrief[] = [];

  currentUserId$: Observable<string>;

  carImageSamples$: Observable<Map<string, Blob>>;

  currentUserId: string = "";
  currentUserFavorites: string[] = [];;

  carImageSamples: Map<string, Blob> = new Map([]);

  constructor(
    private store: Store, 
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog) {

      this.fetchingResults = false;

      this.carImageSamples$ = store.select(selectAllCarImageSamples);
      this.currentUserId$ = store.select(selectLoggedInUserDataId);

    }
  
  ngOnInit(): void {

      this.currentUserId$.subscribe(
        (id) => {
            this.currentUserId = id;
        }
      );

      this.carImageSamples$.subscribe(
        (samples) => {
            this.carImageSamples = samples;
        }
      );

    } 
  
    isFavorite(carId: string): boolean{
        let isFav = false;
        if(this.currentUserFavorites != undefined)
        isFav = (carId === this.currentUserFavorites.find(x => x === carId))!;
        
        return isFav;
    }

    isSeller(sellerId: string): boolean{
        return sellerId === this.currentUserId;
    }

    // toggleFavorite1(carId: string): any{

    //     this.store.dispatch(DealerActions.toggleFavoriteSubmit( {carId: carId, makeFav: !this.isFavorite(carId) }))

    // }
}

  


